import { ForgotPasswordPage } from "@/components/_pages/ForgotPasswordPage/ForgotPasswordPage";
import { HomePage } from "@/components/_pages/HomePage/HomePage";
import { LoginPage } from "@/components/_pages/LoginPage/LoginPage";
import { ModelPage } from "@/components/_pages/ModelPage/ModelPage";
import { NotFoundPage } from "@/components/_pages/NotFoundPage/NotFoundPage";
import { ProfilePage } from "@/components/_pages/ProfilePage/ProfilePage";
import { SignupPage } from "@/components/_pages/SignupPage/SignupPage";
import { Route } from "@/paths";
import React from "react";
import { Outlet } from "react-router-dom";
import { Doc } from "./components/Doc/Doc";
import { RequireAuth } from "./components/RequireAuth/RequireAuth";
import { LayoutBoilerplateText } from "./components/_layouts/LayoutBoilerplateText/LayoutBoilerplateText";
import { AppPage } from "./components/_pages/AppPage/AppPage";
import { AuthActionPage } from "./components/_pages/AuthActionPage/AuthActionPage";
import { CheckoutPage } from "./components/_pages/CheckoutPage/CheckoutPage";
import { CheckoutThankYouPage } from "./components/_pages/CheckoutThankYouPage/CheckoutThankYouPage";
import { ContactPage } from "./components/_pages/ContactPage/ContactPage";
import { ContactSalesPage } from "./components/_pages/ContactSalesPage/ContactSalesPage";
import { ContactsPage } from "./components/_pages/ContactsPage/ContactsPage";
import { DealPage } from "./components/_pages/DealPage/DealPage";
import { DealTrackerPage } from "./components/_pages/DealTrackerPage/DealTrackerPage";
import { ErrorPage } from "./components/_pages/ErrorPage/ErrorPage";
import { ListSignupsPage } from "./components/_pages/ListSignupsPage/ListSignupsPage";
import { ModelLoanPage } from "./components/_pages/ModelPage/Loan/ModelLoanPage";
import { WorkingCapitalPage } from "./components/_pages/ModelPage/WorkingCapital/WorkingCapitalPage";
import { panelManifest } from "./components/_pages/ModelPage/panelManifest";
import { ModelsPage } from "./components/_pages/ModelsPage/ModelsPage";
import { PricingPage } from "./components/_pages/PricingPage/PricingPage";
import { TrackerPage } from "./components/_pages/TrackerPage/TrackerPage";
import { WaitlistPage } from "./components/_pages/WaitlistPage/WaitlistPage";

export const routes = [
  {
    ...(import.meta.env.PROD ? { errorElement: <ErrorPage /> } : {}),
    element: <TrackerPage />,
    children: [
      {
        path: Route.Home,
        element: <HomePage />,
      },
      {
        path: Route.Login,
        element: <LoginPage />,
      },
      {
        path: Route.Signup,
        element: <SignupPage />,
      },
      {
        path: Route.Waitlist,
        element: <WaitlistPage />,
      },
      {
        path: Route.ForgotPassword,
        element: <ForgotPasswordPage />,
      },
      {
        path: Route.AuthAction,
        element: <AuthActionPage />,
      },
      {
        path: Route.Pricing,
        element: <PricingPage />,
      },
      {
        path: Route.ContactSales,
        element: <ContactSalesPage />,
      },
      {
        path: Route.Model,
        element: <ModelPage />,
        children: [
          {
            element: <ModelLoanPage />,
            children: [
              {
                path: "",
                element: React.createElement(panelManifest[0].panel),
              },
              ...panelManifest
                .map((panel) => {
                  const Panel = panel.panel;
                  return {
                    path: panel.path,
                    element: <Panel />,
                  };
                })
                .filter((panel) => panel.path !== "working-capital"),
            ],
          },
          {
            path: "working-capital",
            element: <WorkingCapitalPage />,
          },
        ],
      },

      {
        element: <RequireAuth />,
        children: [
          {
            path: Route.Checkout,
            element: <CheckoutPage />,
          },
          {
            path: Route.CheckoutThankYou,
            element: <CheckoutThankYouPage />,
          },
          {
            path: Route.Profile,
            element: <ProfilePage />,
          },

          {
            element: <AppPage />,
            children: [
              {
                path: Route.DealTracker,
                element: <DealTrackerPage />,
              },
              {
                path: Route.Models,
                element: <ModelsPage />,
              },
              {
                path: Route.Contacts,
                element: <ContactsPage />,
              },
            ],
          },

          {
            path: Route.Deal,
            element: <DealPage />,
          },

          {
            path: Route.Contact,
            element: <ContactPage />,
          },
          {
            path: "listSignups",
            element: <ListSignupsPage />,
          },
        ],
      },

      // Legal routes
      {
        element: (
          <LayoutBoilerplateText>
            <Outlet />
          </LayoutBoilerplateText>
        ),
        children: [
          {
            path: Route.PrivacyPolicy,
            element: <Doc path="@/docs/pages/privacy-policy.mdx" />,
          },
          {
            path: Route.TermOfService,
            element: <Doc path="@/docs/pages/terms-of-service.mdx" />,
          },
          {
            path: Route.AboutUs,
            element: <Doc path="@/docs/pages/about-us.mdx" />,
          },
        ],
      },

      {
        path: Route.NotFound,
        element: <NotFoundPage />,
      },
    ],
  },
];

export { Route };
